module.exports = function isTwelveHourTime(groups) {
    return /[a-z]/i.test(groups[groups.length - 1]);
};



// WEBPACK FOOTER //
// ./src/TimeInput/lib/is-twelve-hour-time.js